import React, {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import ValidarCorreoElectronico from '../functions/ValidarCorreoElectronico';
import ValidarUsuario from '../functions/ValidarUsuario';
import ProcesarPadron from "../functions/ProcesarPadron";

// Styles
import '../styles/MapModal.css';

// Iconos
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import PeopleIcon from '@mui/icons-material/People';
import LanguageIcon from '@mui/icons-material/Language';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import HailIcon from '@mui/icons-material/Hail';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import HandshakeIcon from '@mui/icons-material/Handshake';

// Imágenes
import logografico from './../assets/images/isotipo.png'
import logotexto from './../assets/images/logotipo.jpg'

// Indicador de procesamiento
import CircularProgress from '@mui/material/CircularProgress';

// Store de admin
import adminStore from '../store/admin';

// para manipular las rutas con wouter
import { navigate } from "wouter/use-browser-location";
import { useLocation } from 'wouter';
import { Link } from 'wouter';

// Componentes
import { ListarSocios } from '../components/ListarSocios';
import { EditarSocio } from '../components/EditarSocio';
import CredencialModal from '../components/CredencialModal';
import { ListarPlanes } from "../components/ListarPlanes";
import { EditarPlan } from "../components/EditarPlan";
import { ListarPaises } from '../components/ListarPaises';
import { EditarPais } from '../components/EditarPais';
import { ListarProvincias } from '../components/ListarProvincias';
import SeleccionarPais from '../components/SeleccionarPais';
import SeleccionarProvincia from "../components/SeleccionarProvincia";
import { EditarProvincia } from '../components/EditarProvincia';
import { ListarLocalidades } from "../components/ListarLocalidades";
import { EditarLocalidad } from "../components/EditarLocalidad";
import { ListarPrestadores } from "../components/ListarPrestadores";
import { EditarPrestador } from "../components/EditarPrestador";
import MapModal from "../components/MapModal";
import { ListarPreguntasFrecuentes } from "../components/ListarPreguntasFrecuentes";
import { EditarPreguntaFrecuente } from "../components/EditarPreguntaFrecuente";
import { ListarAgentesComerciales } from "../components/ListarAgentesComerciales";
import { EditarAgenteComercial } from "../components/EditarAgenteComercial";
import { ListarEspecialidades } from "../components/ListarEspecialidades";
import { EditarEspecialidad } from "../components/EditarEspecialidad";
import { ListarRubros } from "../components/ListarRubros";
import { EditarRubro } from "../components/EditarRubro";
import { ListarServicios } from "../components/ListarServicios";
import { EditarServicio } from "../components/EditarServicio";
import { ListarPartners } from "../components/ListarPartners";
import { EditarPartner } from "../components/EditarPartner";

// Tipos
import SocioTabla from '../types/SocioTabla';
import SocioEditar from '../types/SocioEditar';
import PaisTabla from "../types/PaisTabla";
import PaisEditar from "../types/PaisEditar";
import PaisSeleccionar from "../types/PaisSeleccionar";
import ProvinciaTabla from "../types/ProvinciaTabla";
import ProvinciaSeleccionar from "../types/ProvinciaSeleccionar";
import LocalidadTabla from "../types/LocalidadTabla";
import PrestadorTabla from "../types/PrestadorTabla";
import Ubicacion from "../types/Ubicacion";
import PreguntaFrecuenteTabla from "../types/PreguntaFrecuenteTabla";
import ComercialTabla from "../types/ComercialTabla";
import EspecialidadesTabla from "../types/EspecialidadesTabla";
import RubrosTabla from "../types/RubrosTabla";
import PlanTabla from "../types/PlanTabla";
import PlanEditar from "../types/PlanEditar";
import ServiciosTabla from "../types/ServiciosTabla";
import ServiciosEditar from "../types/ServiciosEditar";
import PartnersEditar from "../types/PartnersEditar";

function Admin() {

    // Variables del store de admin
    const {usuarioEmail, setUsuarioEmail} = adminStore();
    const {usuarioNombre, setUsuarioNombre} = adminStore();
    const {usuarioApellido, setUsuarioApellido} = adminStore();
    const {usuarioNivel, setUsuarioNivel} = adminStore();
    const {usuarioId, setUsuarioId} = adminStore();
    const {usuarioCelular, setUsuarioCelular} = adminStore();
    const {seleccionActual, setSeleccionActual} = adminStore();
    const {accionActual, setAccionActual} = adminStore();

    const [procesandoPadron, setProcesandoPadron] = useState(false);
    const [padronSubido, setPadronSubido] = useState(false);
    const [fileNameUpload, setFileNameUpload] = useState<string | null>(null);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [errorUpload, setErrorUpload] = useState<string>('');

    const [mensajeError, setMensajeError] = useState<string>('');
    const [registrosNuevos, setRegistrosNuevos] = useState<number>(0);
    const [registrosActualizados, setRegistrosActualizados] = useState<number>(0);
    const [padron, setPadron] = useState<string>('');


    // Para gestión de socios
    const [elSocio, setElSocio] = useState<SocioTabla | null>(null);
    const [verCredencial, setVerCredencial] = useState<boolean>(false);

    // Para gestión de planes
    const [elPlan, setElPlan] = useState<PlanTabla | null>(null);

    // Para gestión de paises
    const [elPais, setElPais] = useState<PaisTabla | null>(null);

    // Para gestión de Provincias
    const [elPaisSeleccionado, setElPaisSeleccionado] = useState<PaisSeleccionar | null>(null);
    const [laProvincia, setLaProvincia] = useState<ProvinciaTabla | null>(null);
    const [paisSinSeleccionar, setPaisSinSeleccionar] = useState<PaisSeleccionar>({id:0, iso_code:'', tel_code:'', name:''});

    // Para gestión de localidades
    const [laProvinciaSeleccionada, setLaProvinciaSeleccionada] = useState<ProvinciaSeleccionar | null>(null);
    const [laLocalidad, setLaLocalidad] = useState<LocalidadTabla | null>(null);
    const [provinciaSinSeleccionar, setProvinciaSinSeleccionar] = useState<ProvinciaSeleccionar>({id:0, name:''});

    // Para gestión de prestadores
    const [elPrestador, setElPrestador] = useState<PrestadorTabla | null>(null);
    const [mapaIsOpen, setMapaIsOpen] = useState<boolean>(false);

    // Para preguntas frecuentes
    const [preguntaFrecuente, setPreguntaFrecuente] = useState<PreguntaFrecuenteTabla | null>(null);

    // Para agentes comerciales
    const [agenteComercial, setAgenteComercial] = useState<ComercialTabla | null>(null);

    // Para Especialidades
    const [especialidad, setEspecialidad] = useState<EspecialidadesTabla | null>(null);

    // Para Rubros (pendiente cambio el tipo)
    const [rubro, setRubro] = useState<RubrosTabla | null>(null);

    // Para Servicios
    const [servicio, setServicio] = useState<ServiciosEditar | null>(null);

    // Para Partners
    const [partner, setPartner] = useState<PartnersEditar | null>(null);

    const [laUbicacion, setLaUbicacion] = useState<Ubicacion>({name:'', latitude:0, longitude:0, address:'', additionalInfo:''});

    // Funciones para subir archivos
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        //console.log(event.target.files?.[0]);
        setErrorUpload('');
        const file = event.target.files?.[0];
        if (file) {
          if (!file.name.endsWith('.xlsx')) {
            setErrorUpload('Seleccione un archivo con extensión .xlsx');
            return;
          }
          setFileNameUpload(file.name);
          setFileUpload(file);
        }
      };
    
      const handleDrop = (event: React.DragEvent<HTMLLabelElement>) => {
        event.preventDefault();
        setErrorUpload('');
        const file = event.dataTransfer.files?.[0];
        if (file) {
          if (!file.name.endsWith('.xlsx')) {
            setErrorUpload('Please upload a file with .xlsx extension');
            return;                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarplanes' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarplanes')}><AccountTreeIcon className="mr-2"/>Planes</Link>
                            </li>

          }
          setFileNameUpload(file.name);
          setFileUpload(file);
        }
      };
    
      const handleDragOver = (event: React.DragEvent<HTMLLabelElement>) => {
        event.preventDefault();
      };
    
      const handleDelete = () => {
        setFileNameUpload(null);
        setFileUpload(null);
      };
    

      const convertToBase64 = (file: File): Promise<string | ArrayBuffer | null> => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      };

      const handleUpload = async () => {
        if (!fileUpload) return;
    
        try {
            const base64 = await convertToBase64(fileUpload);
            if (typeof base64 === 'string') {
                const soloBase64 = base64.toString().split(',')[1];
                setProcesandoPadron(true);
                const response = await ProcesarPadron(fileNameUpload as string, soloBase64 as string);
                if (response && response.padron_ok === 'si') {
                    setMensajeError('');
                    setProcesandoPadron(false);
                    setFileNameUpload(null);
                    setFileUpload(null);
                    setPadronSubido(true);
                    setPadron(response.padron);
                    setRegistrosNuevos(response.registros_nuevos);
                    setRegistrosActualizados(response.registros_actualizados);

                } else {
                    setMensajeError(response.mensaje);
                    setFileNameUpload(null);
                    setFileUpload(null);
                    setProcesandoPadron(false);
                    setPadron('');
                    setRegistrosActualizados(0);
                    setRegistrosNuevos(0);
                    setPadronSubido(false);
                }
            }
        } catch (error) {
          console.error('Error subiendo el archivo:', error);
          alert('Error subiendo el archivo');
        }
      };

    // SOCIOS
    // Para la edición de socios
    const handleEditSocioAdmin = (socio: SocioTabla) => {
        setElSocio(socio);
        setAccionActual('editar');
    };

    const handleDeleteSocioAdmin = (socio: SocioTabla) => {
        setElSocio(socio);
        setAccionActual('eliminar');
    };

    // Para guardar un socio
    const handleGuardarCambios = (socio: SocioEditar) => {
        setSeleccionActual('socios');
        setAccionActual('');
    };

    // Para cancelar el cambio de socios
    const handleCancelarCambios = () => {
        setSeleccionActual('socios');
        setAccionActual('');
    };

    const cambiarClave = () => {
        navigate('/cambiarclave');
    }

    const cerrarSesion = () => {
        setUsuarioEmail('');
        setUsuarioNombre('');
        setUsuarioApellido('');
        setUsuarioNivel('');
        setUsuarioId(0);
        setUsuarioCelular('');
        setSeleccionActual('');
        navigate('/login');
    };

    const handleMostrarCredencialLocal = (socio: SocioTabla) => {
        setElSocio(socio);
        setVerCredencial(true);
    }

    // PLANES
    // Para la edición de planes
    const handleEditPlanAdmin = (plan: PlanTabla) => {
        setElPlan(plan);
        setSeleccionActual('listarplanes');
        setAccionActual('editar');
    };

    const handleDeletePlanAdmin = (plan: PlanTabla) => {
        setElPlan(plan);
        setSeleccionActual('listarplanes');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosPlanAdmin = (plan: PlanEditar) => {
        setSeleccionActual('listarplanes');
        setAccionActual('');
    };

    const handleCancelarCambiosPlanAdmin = () => {
        setSeleccionActual('listarplanes');
        setAccionActual('');
    };

    const handleAddPlanAdmin = () => {
        setSeleccionActual('listarplanes');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // PAISES
    // Para la edición de paises
    const handleEditPaisAdmin = (pais: PaisTabla) => {
        setElPais(pais);
        setSeleccionActual('listarpaises');
        setAccionActual('editar');
    };

    const handleDeletePaisAdmin = (pais: PaisTabla) => {
        setElPais(pais);
        setSeleccionActual('listarpaises');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosPaisAdmin = (pais: PaisEditar) => {
        setSeleccionActual('listarpaises');
        setAccionActual('');
    };

    const handleCancelarCambiosPaisAdmin = () => {
        setSeleccionActual('listarpaises');
        setAccionActual('');
    };

    const handleAddPaisAdmin = () => {
        setSeleccionActual('listarpaises');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // PROVINCIAS
    // Para la edición de provincias
    const handleSeleccionarPais = (paisSeleccionado: PaisSeleccionar | null) => {
        if (paisSeleccionado) {
            setElPaisSeleccionado(paisSeleccionado);
        }
    };

    const handleClearSeleccionarPais = () => {
        setElPaisSeleccionado({id:0, iso_code:'', tel_code:'', name:''});
    };

    const handleEditProvinciaAdmin = (provincia: ProvinciaTabla) => {
        setLaProvincia(provincia);
        setSeleccionActual('listarprovincias');
        setAccionActual('editar');
    };

    const handleDeleteProvinciaAdmin = (provincia: ProvinciaTabla) => {
        setLaProvincia(provincia);
        setSeleccionActual('listarprovincias');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosProvinciaAdmin = (provincia: ProvinciaTabla) => {
        setSeleccionActual('listarprovincias');
        setAccionActual('');
    };

    const handleCancelarCambiosProvinciaAdmin = () => {
        setSeleccionActual('listarprovincias');
        setAccionActual('');
    };

    const handleAddProvinciaAdmin = () => {
        setSeleccionActual('listarprovincias');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // LOCALIDADES
    // Para la edición de localidades
    const handleSeleccionarPaisLocalidad = (paisSeleccionado: PaisSeleccionar | null) => {
        if (paisSeleccionado) {
            setElPaisSeleccionado(paisSeleccionado);
        }
    };

    const handleClearSeleccionarPaisLocalidad = () => {
        setElPaisSeleccionado({id:0, iso_code:'', tel_code:'', name:''});
        setLaProvinciaSeleccionada({id:0, name:''});
    };

    const handleSeleccionarProvinciaLocalidad = (provinciaSeleccionada: ProvinciaSeleccionar | null) => {
        if (provinciaSeleccionada) {
            setLaProvinciaSeleccionada(provinciaSeleccionada);
        }
    };

    const handleClearSeleccionarProvinciaLocalidad = () => {
        setLaProvinciaSeleccionada({id:0, name:''});
    };

    const handleEditLocalidadAdmin = (localidad: LocalidadTabla) => {
        setLaLocalidad(localidad);
        setSeleccionActual('listarlocalidades');
        setAccionActual('editar');
    };

    const handleDeleteLocalidadAdmin = (localidad: LocalidadTabla) => {
        setLaLocalidad(localidad);
        setSeleccionActual('listarlocalidades');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosLocalidadAdmin = (localidad: LocalidadTabla) => {
        setSeleccionActual('listarlocalidades');
        setAccionActual('');
    };

    const handleCancelarCambiosLocalidadAdmin = () => {
        setSeleccionActual('listarlocalidades');
        setAccionActual('');
    };

    const handleAddLocalidadAdmin = () => {
        setSeleccionActual('listarlocalidades');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // PRESTADORES
    // Para la edición de prestadores
    const handleEditPrestadorAdmin = (prestador: PrestadorTabla) => {
        setElPrestador(prestador);
        setSeleccionActual('listarprestadores');
        setAccionActual('editar');
    };

    const handleDeletePrestadorAdmin = (prestador: PrestadorTabla) => {
        setElPrestador(prestador);
        setSeleccionActual('listarprestadores');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosPrestadorAdmin = (prestador: PrestadorTabla) => {
        setSeleccionActual('listarprestadores');
        setAccionActual('');
    };

    const handleCancelarCambiosPrestadorAdmin = () => {
        setSeleccionActual('listarprestadores');
        setAccionActual('');
    };

    const handleAddPrestadorAdmin = () => {
        setSeleccionActual('listarprestadores');
        setAccionActual('agregar');
    };

    const handleUbication = (prestador: PrestadorTabla) => {
        const armoUbicacion: Ubicacion = {
            name: prestador.razonsocial.toLowerCase(),
            latitude: parseFloat(prestador.gpslat),
            longitude: parseFloat(prestador.gpslon),
            address: prestador.domicilio,
            additionalInfo: "Whatsapp: " + prestador.whatsapp
        };

        setLaUbicacion(armoUbicacion);
        setMapaIsOpen(true);
    };
    ////////////////////////////////////////////////////////

    
    // PREGUNTAS FRECUENTES
    // Para la edición de preguntas frecuentes
    const handleEditPreguntaFrecuenteAdmin = (preguntafrecuente: PreguntaFrecuenteTabla) => {
        setPreguntaFrecuente(preguntafrecuente);
        setSeleccionActual('listarpreguntasfrecuentes');
        setAccionActual('editar');
    };

    const handleDeletePreguntaFrecuenteAdmin = (preguntafrecuente: PreguntaFrecuenteTabla) => {
        setPreguntaFrecuente(preguntafrecuente);
        setSeleccionActual('listarpreguntasfrecuentes');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosPreguntaFrecuenteAdmin = (preguntafrecuente: PreguntaFrecuenteTabla) => {
        setSeleccionActual('listarpreguntasfrecuentes');
        setAccionActual('');
    };

    const handleCancelarCambiosPreguntaFrecuenteAdmin = () => {
        setSeleccionActual('listarpreguntasfrecuentes');
        setAccionActual('');
    };

    const handleAddPreguntaFrecuenteAdmin = () => {
        setSeleccionActual('listarpreguntasfrecuentes');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


   // AGENTES COMERCIALES
    // Para la edición de agentes comerciales
    const handleEditAgenteComercialAdmin = (agentecomercial: ComercialTabla) => {
        setAgenteComercial(agentecomercial);
        setSeleccionActual('listarcomerciales');
        setAccionActual('editar');
    };

    const handleDeleteAgenteComercialAdmin = (agentecomercial: ComercialTabla) => {
        setAgenteComercial(agentecomercial);
        setSeleccionActual('listarcomerciales');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosAgenteComercialAdmin = (agentecomercial: ComercialTabla) => {
        setSeleccionActual('listarcomerciales');
        setAccionActual('');
    };

    const handleCancelarCambiosAgenteComercialAdmin = () => {
        setSeleccionActual('listarcomerciales');
        setAccionActual('');
    };

    const handleAddAgenteComercialAdmin = () => {
        setSeleccionActual('listarcomerciales');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


   // ESPECIALIDADES
    // Para la edición de especialidades
    const handleEditEspecialidadAdmin = (especialidad: EspecialidadesTabla) => {
        setEspecialidad(especialidad);
        setSeleccionActual('listarespecialidades');
        setAccionActual('editar');
    };

    const handleDeleteEspecialidadAdmin = (especialidad: EspecialidadesTabla) => {
        setEspecialidad(especialidad);
        setSeleccionActual('listarespecialidades');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosEspecialidadAdmin = (especialidad: EspecialidadesTabla) => {
        setSeleccionActual('listarespecialidades');
        setAccionActual('');
    };

    const handleCancelarCambiosEspecialidadAdmin = () => {
        setSeleccionActual('listarespecialidades');
        setAccionActual('');
    };

    const handleAddEspecialidadAdmin = () => {
        setSeleccionActual('listarespecialidades');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // RUBROS
    // Para la edición de rubros
    const handleEditRubroAdmin = (rubro: RubrosTabla) => {
        setRubro(rubro);
        setSeleccionActual('listarrubros');
        setAccionActual('editar');
    };

    const handleDeleteRubroAdmin = (rubro: RubrosTabla) => {
        setRubro(rubro);
        setSeleccionActual('listarrubros');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosRubroAdmin = (rubro: RubrosTabla) => {
        setSeleccionActual('listarrubros');
        setAccionActual('');
    };

    const handleCancelarCambiosRubroAdmin = () => {
        setSeleccionActual('listarrubros');
        setAccionActual('');
    };

    const handleAddRubroAdmin = () => {
        setSeleccionActual('listarrubros');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // Servicios
    // Para la edición de servicios
    const handleEditServicioAdmin = (servicio: ServiciosEditar | ServiciosEditar) => {
        setServicio(servicio);
        setSeleccionActual('listarservicios');
        setAccionActual('editar');
    };

    const handleDeleteServicioAdmin = (servicio: ServiciosEditar) => {
        setServicio(servicio);
        setSeleccionActual('listarservicios');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosServicioAdmin = (servicio: ServiciosEditar) => {
        setSeleccionActual('listarservicios');
        setAccionActual('');
    };

    const handleCancelarCambiosServicioAdmin = () => {
        setSeleccionActual('listarservicios');
        setAccionActual('');
    };

    const handleAddServicioAdmin = () => {
        setSeleccionActual('listarservicios');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    // Partners
    // Para la edición de partners
    const handleEditPartnerAdmin = (partner: PartnersEditar | PartnersEditar) => {
        setPartner(partner);
        setSeleccionActual('listarpartners');
        setAccionActual('editar');
    };

    const handleDeletePartnerAdmin = (partner: PartnersEditar) => {
        setPartner(partner);
        setSeleccionActual('listarpartners');
        setAccionActual('eliminar');
    };

    const handleGuardarCambiosPartnerAdmin = (partner: PartnersEditar) => {
        setSeleccionActual('listarpartners');
        setAccionActual('');
    };

    const handleCancelarCambiosPartnerAdmin = () => {
        setSeleccionActual('listarpartners');
        setAccionActual('');
    };

    const handleAddPartnerAdmin = () => {
        setSeleccionActual('listarpartners');
        setAccionActual('agregar');
    };
    ////////////////////////////////////////////////////////


    useEffect(() => {
        if (usuarioEmail === '') {
            setUsuarioEmail('');
            setUsuarioNombre('');
            setUsuarioApellido('');
            setUsuarioNivel('');
            setUsuarioId(0);
            setUsuarioCelular('');
            navigate('/login');
        }
    }, []);

    /*useEffect(() => {
        console.log('El socio:', elSocio); 
    },[elSocio]);*/

    return (
        <div className='container-fluid flex flex-col items-center justify-center'>
            <header className="bg-white text-black w-full py-4 px-6 border-b-2 border-b-vp-plan-5 min-w-[700px]">
                <div className="flex flex-row w-full justify-between items-center">
                    <img src={logotexto} className="h-8 flex" alt="VidaPlus Logo" />
                    <h1 className="font-metropolis text-xl font-bold">Panel de Administración</h1>
                    <div className="flex flex-row justify-center items-center space-x-2">
                        <div className="flex flex-row flex-nowrap">
                            <h3 className="font-metropolis font-bold text-sm">Usuario:</h3>
                            <h3 className="font-metropolis font-regular text-sm ml-2">{usuarioApellido.trim() + ', ' + usuarioNombre.trim()}</h3>
                        </div>
                        <div className="flex flex-row flex-nowrap">
                            <h3 className="font-metropolis font-bold text-sm">Nivel:</h3>
                            <h3 className="font-metropolis font-regular text-sm ml-2">{usuarioNivel}</h3>
                        </div>
                        <div className="flex flex-row flex-nowrap space-x-2">
                            <input type="button" className="vp-btn-verde-sm" value="Cambiar Clave" onClick={cambiarClave} />
                            <input type="button" className="vp-btn-azul-sm" value="Cerrar Sesión" onClick={cerrarSesion} />
                        </div>
                        
                    </div>
                </div>
            </header>
            <div className="flex flex-row w-full h-screen bg-white">
                <aside className="bg-white text-black w-1/6 min-w-[160px] border-r-2 border-vp-plan-5">
                    <nav className="">
                        <ul className="">
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'upload' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('upload')}><CloudUploadIcon className="mr-2"/>Subir padrón</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'socios' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('socios')}><PeopleIcon className="mr-2"/>Socios</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarplanes' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarplanes')}><AccountTreeIcon className="mr-2"/>Planes</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarservicios' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarservicios')}><MiscellaneousServicesIcon className="mr-2"/>Servicios</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarpaises' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarpaises')}><LanguageIcon className="mr-2"/>Paises</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarprovincias' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarprovincias')}><ShareLocationIcon className="mr-2"/>Provincias</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarlocalidades' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarlocalidades')}><LocationOnIcon className="mr-2"/>Localidades</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarprestadores' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarprestadores')}><ApartmentIcon className="mr-2"/>Prestadores</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarpreguntasfrecuentes' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarpreguntasfrecuentes')}><LiveHelpIcon className="mr-2"/>Preguntas Frecuentes</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarcomerciales' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarcomerciales')}><HailIcon className="mr-2"/>Agentes Comerciales</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarespecialidades' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarespecialidades')}><MedicalServicesIcon className="mr-2"/>Especialidades</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarrubros' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarrubros')}><AppRegistrationIcon className="mr-2"/>Rubros</Link>
                            </li>
                            <li className="">
                                <Link to="/admin" className={`${seleccionActual === 'listarpartners' ? 'vp-admin-option-selected' : 'vp-admin-option'}`} onClick={() => setSeleccionActual('listarpartners')}><HandshakeIcon className="mr-2"/>Partners</Link>
                            </li>
                        </ul>
                    </nav>
                </aside>
                {/* Contenido principal en base a la selección */} 
                <main className="flex flex-col justify-start items-center w-full bg-white border-r-2 border-vp-plan-5 pb-5">
                    {seleccionActual === '' && (
                        <div className="flex flex-col justify-center items-center w-full h-full">
                            <h2 className="text-2xl font-bold">Bienvenido al Panel de Administración</h2>
                            <p className="text-lg">Seleccione una opción del menú lateral</p>
                        </div>
                    )}

                    {/* Upload de padron */}
                    {(seleccionActual === 'upload' && !padronSubido && !procesandoPadron && !mensajeError) && (
                        <div className="flex flex-col items-center justify-center w-[75%] xxs:w-[95%] xs:w-[90%] sm:w-[85%] min-w-[400px] mt-5">
                            <label
                                htmlFor="dropzone-file"
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:hover:bg-gray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500"
                            >
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                    <CloudUploadIcon fontSize="large" className=""/>
                                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Haga clic en <span className="underline">Upload</span></span> or arrastre y suelte el archivo aquí</p>
                                    <p className="text-xs text-gray-500 dark:text-gray-400">xlsx file</p>
                                    {fileNameUpload && (
                                        <p className="font-metropolis font-bold text-md text-vp-plan-5 dark:text-gray-400 mt-2">{fileNameUpload}</p>
                                    )}
                                </div>
                            </label>
                            <input id="dropzone-file" type="file" className="hidden" onChange={handleFileChange} />
                            {errorUpload && <p style={{ color: 'red' }}>{errorUpload}</p>}
                            {fileNameUpload && (
                                <div className="flex justify-between items-center mt-4">
                                <button
                                    onClick={handleUpload}
                                    className="px-4 py-2 bg-blue-600 text-white rounded-md"
                                >
                                    Confirmar Archivo
                                </button>
                                <button
                                    onClick={handleDelete}
                                    className="ml-2 px-4 py-2 bg-red-600 text-white rounded-md flex items-center"
                                >
                                    <DeleteIcon className="mr-2" /> Eliminar Archivo
                                </button>
                                </div>
                            )}
                        </div>
                    )}
                    {(seleccionActual === 'upload' && procesandoPadron) && (
                        <div className="flex flex-col items-center justify-center w-full h-full">
                            <h2 className="text-2xl font-bold">Procesando padrón...</h2>
                            <p className="text-lg">Por favor espere</p>
                            <CircularProgress />
                        </div>
                    )}
                    {(seleccionActual === 'upload' && padronSubido && !procesandoPadron) && (
                        <div className="flex flex-col items-center justify-center w-full h-full">
                            <h2 className="text-2xl font-bold text-vp-verde">Padrón subido correctamente!</h2>
                            <div className="flex flex-col flex-nowrap justify-start items-start border rounded-md border-gray-600 bg-slate-200 p-2 shadow-md shadow-black">
                                <p className="text-lg"><strong>Padrón procesado:</strong> {padron}</p>
                                <p className="text-lg"><strong>Registros nuevos:</strong> {registrosNuevos}</p>
                                <p className="text-lg"><strong>Registros actualizados:</strong> {registrosActualizados}</p>
                            </div>
                        </div>
                    )}
                    {(seleccionActual === 'upload' && mensajeError !== '') && (
                        <div className="flex flex-col items-center justify-center w-full h-full">
                            <h2 className="text-2xl font-bold text-vp-rojo">Error subiendo el padrón</h2>
                            <div className="flex flex-col flex-nowrap justify-start items-start border rounded-md border-gray-600 bg-slate-200 p-2 shadow-md shadow-black">
                                <p className="text-lg">{mensajeError}</p>
                            </div>
                        </div>
                    )}

                    {/* Socios */}
                    {(seleccionActual === 'socios' && accionActual === '') && (
                        <div>
                            <ListarSocios defaultItemsPerPage={10} handleEditSocio={handleEditSocioAdmin} handleDeleteSocio={handleDeleteSocioAdmin} handleMostrarCredencial={handleMostrarCredencialLocal}/>
                            <CredencialModal nroDocumento={elSocio?.documento || ''} isVisible={verCredencial} setIsVisible={setVerCredencial} />
                        </div>
                    )}
                    {(seleccionActual === 'socios' && accionActual === 'editar') && (
                        <div className="flex flex-col items-center justify-start w-full h-full mt-5">
                            <EditarSocio idSocio={elSocio?.id || 0} guardarCambios={handleGuardarCambios} cancelarCambios={handleCancelarCambios} />
                        </div>
                    )}

                    {/* Planes */}
                    {seleccionActual === 'listarplanes' && accionActual === '' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <ListarPlanes defaultItemsPerPage={10} handleEditPlan={handleEditPlanAdmin} handleDeletePlan={handleDeletePlanAdmin} handleAddPlan={handleAddPlanAdmin}/>
                        </div>
                    )}
                    {seleccionActual === 'listarplanes' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPlan idPlan={elPlan?.id || 0} guardarCambios={handleGuardarCambiosPlanAdmin} cancelarCambios={handleCancelarCambiosPlanAdmin} eliminandoPlan={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarplanes' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPlan idPlan={0} guardarCambios={handleGuardarCambiosPlanAdmin} cancelarCambios={handleCancelarCambiosPlanAdmin} eliminandoPlan={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarplanes' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPlan idPlan={elPlan?.id || 0} guardarCambios={handleGuardarCambiosPlanAdmin} cancelarCambios={handleCancelarCambiosPlanAdmin} eliminandoPlan={true}/>
                        </div>
                    )}


                    {/* Paises */}
                    {seleccionActual === 'listarpaises' && accionActual === '' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <ListarPaises defaultItemsPerPage={10} handleEditPais={handleEditPaisAdmin} handleDeletePais={handleDeletePaisAdmin} handleAddPais={handleAddPaisAdmin}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpaises' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPais idPais={elPais?.id || 0} guardarCambios={handleGuardarCambiosPaisAdmin} cancelarCambios={handleCancelarCambiosPaisAdmin} eliminandoPais={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpaises' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPais idPais={0} guardarCambios={handleGuardarCambiosPaisAdmin} cancelarCambios={handleCancelarCambiosPaisAdmin} eliminandoPais={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpaises' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPais idPais={elPais?.id || 0} guardarCambios={handleGuardarCambiosPaisAdmin} cancelarCambios={handleCancelarCambiosPaisAdmin} eliminandoPais={true}/>
                        </div>
                    )}

                    {/* Provincias */}
                    {seleccionActual === 'listarprovincias' && accionActual === '' && (
                        <div className="flex flex-col justify-start items-center w-full h-full mt-4 mb-2 px-6">
                            <SeleccionarPais paisInicial={elPaisSeleccionado?.id || 0} onChange={handleSeleccionarPais} onClear={handleClearSeleccionarPais} eliminando={false}/>
                                {(elPaisSeleccionado?.id || 0 > 0) && (
                                    <ListarProvincias defaultItemsPerPage={10} handleEdit={handleEditProvinciaAdmin} handleDelete={handleDeleteProvinciaAdmin} handleAdd={handleAddProvinciaAdmin} pais={elPaisSeleccionado || paisSinSeleccionar}/>
                                )}                            
                        </div>
                    )}
                    {seleccionActual === 'listarprovincias' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarProvincia idPais={elPaisSeleccionado?.id || 0} idProvincia={laProvincia?.id || 0} guardarCambios={handleGuardarCambiosProvinciaAdmin} cancelarCambios={handleCancelarCambiosProvinciaAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarprovincias' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarProvincia idPais={elPaisSeleccionado?.id || 0} idProvincia={0} guardarCambios={handleGuardarCambiosProvinciaAdmin} cancelarCambios={handleCancelarCambiosProvinciaAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarprovincias' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarProvincia idPais={elPaisSeleccionado?.id || 0} idProvincia={laProvincia?.id || 0} guardarCambios={handleGuardarCambiosProvinciaAdmin} cancelarCambios={handleCancelarCambiosProvinciaAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Localidades */}
                    {seleccionActual === 'listarlocalidades' && accionActual === '' && (
                        <div className="flex flex-col justify-start items-center w-full h-full mt-4 mb-2 px-6">
                            <SeleccionarPais paisInicial={elPaisSeleccionado?.id || 0} onChange={handleSeleccionarPaisLocalidad} onClear={handleClearSeleccionarPaisLocalidad} eliminando={false} />
                            {(elPaisSeleccionado?.id || 0 > 0) && (
                                <div className="flex flex-col justify-start items-center w-full mt-4 mb-2">
                                    <SeleccionarProvincia paisInicial={elPaisSeleccionado?.id || 0} provinciaInicial={laProvinciaSeleccionada?.id || 0} onChange={handleSeleccionarProvinciaLocalidad} onClear={handleClearSeleccionarProvinciaLocalidad} eliminando={false}/>
                                </div>
                            )}
                            {((laProvinciaSeleccionada?.id || 0 > 0) && (elPaisSeleccionado?.id || 0 > 0)) && (
                                <ListarLocalidades defaultItemsPerPage={10} handleEdit={handleEditLocalidadAdmin} handleDelete={handleDeleteLocalidadAdmin} handleAdd={handleAddLocalidadAdmin} pais={elPaisSeleccionado || paisSinSeleccionar} provincia={laProvinciaSeleccionada || provinciaSinSeleccionar}/>
                            )}
                        </div>
                    )}
                    {seleccionActual === 'listarlocalidades' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarLocalidad idPais={elPaisSeleccionado?.id || 0} idProvincia={laProvinciaSeleccionada?.id || 0} idLocalidad={laLocalidad?.id || 0} guardarCambios={handleGuardarCambiosLocalidadAdmin} cancelarCambios={handleCancelarCambiosLocalidadAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarlocalidades' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarLocalidad idPais={elPaisSeleccionado?.id || 0} idProvincia={laProvinciaSeleccionada?.id || 0} idLocalidad={0} guardarCambios={handleGuardarCambiosLocalidadAdmin} cancelarCambios={handleCancelarCambiosLocalidadAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarlocalidades' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarLocalidad idPais={elPaisSeleccionado?.id || 0} idProvincia={laProvinciaSeleccionada?.id || 0} idLocalidad={laLocalidad?.id || 0} guardarCambios={handleGuardarCambiosLocalidadAdmin} cancelarCambios={handleCancelarCambiosLocalidadAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Prestadores */}
                    {seleccionActual === 'listarprestadores' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarPrestadores defaultItemsPerPage={10} handleEdit={handleEditPrestadorAdmin} handleDelete={handleDeletePrestadorAdmin} handleAdd={handleAddPrestadorAdmin} handleUbication={handleUbication} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarprestadores' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPrestador idPrestador={elPrestador?.id || 0} guardarCambios={handleGuardarCambiosPrestadorAdmin} cancelarCambios={handleCancelarCambiosPrestadorAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarprestadores' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPrestador idPrestador={0} guardarCambios={handleGuardarCambiosPrestadorAdmin} cancelarCambios={handleCancelarCambiosPrestadorAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarprestadores' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPrestador idPrestador={elPrestador?.id || 0} guardarCambios={handleGuardarCambiosPrestadorAdmin} cancelarCambios={handleCancelarCambiosPrestadorAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Preguntas frecuentes */}
                    {seleccionActual === 'listarpreguntasfrecuentes' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarPreguntasFrecuentes defaultItemsPerPage={10} handleEdit={handleEditPreguntaFrecuenteAdmin} handleDelete={handleDeletePreguntaFrecuenteAdmin} handleAdd={handleAddPreguntaFrecuenteAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarpreguntasfrecuentes' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPreguntaFrecuente idPreguntaFrecuente={preguntaFrecuente?.id || 0} guardarCambios={handleGuardarCambiosPreguntaFrecuenteAdmin} cancelarCambios={handleCancelarCambiosPreguntaFrecuenteAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpreguntasfrecuentes' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPreguntaFrecuente idPreguntaFrecuente={0} guardarCambios={handleGuardarCambiosPreguntaFrecuenteAdmin} cancelarCambios={handleCancelarCambiosPreguntaFrecuenteAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpreguntasfrecuentes' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPreguntaFrecuente idPreguntaFrecuente={preguntaFrecuente?.id || 0} guardarCambios={handleGuardarCambiosPreguntaFrecuenteAdmin} cancelarCambios={handleCancelarCambiosPreguntaFrecuenteAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Agentes Comerciales */}
                    {seleccionActual === 'listarcomerciales' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarAgentesComerciales defaultItemsPerPage={10} handleEdit={handleEditAgenteComercialAdmin} handleDelete={handleDeleteAgenteComercialAdmin} handleAdd={handleAddAgenteComercialAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarcomerciales' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarAgenteComercial idAgenteComercial={agenteComercial?.id || 0} guardarCambios={handleGuardarCambiosAgenteComercialAdmin} cancelarCambios={handleCancelarCambiosAgenteComercialAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarcomerciales' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarAgenteComercial idAgenteComercial={0} guardarCambios={handleGuardarCambiosAgenteComercialAdmin} cancelarCambios={handleCancelarCambiosAgenteComercialAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarcomerciales' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarAgenteComercial idAgenteComercial={agenteComercial?.id || 0} guardarCambios={handleGuardarCambiosAgenteComercialAdmin} cancelarCambios={handleCancelarCambiosAgenteComercialAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Especialidades */}
                    {seleccionActual === 'listarespecialidades' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarEspecialidades defaultItemsPerPage={10} handleEdit={handleEditEspecialidadAdmin} handleDelete={handleDeleteEspecialidadAdmin} handleAdd={handleAddEspecialidadAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarespecialidades' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarEspecialidad idEspecialidad={especialidad?.id || 0} guardarCambios={handleGuardarCambiosEspecialidadAdmin} cancelarCambios={handleCancelarCambiosEspecialidadAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarespecialidades' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarEspecialidad idEspecialidad={0} guardarCambios={handleGuardarCambiosEspecialidadAdmin} cancelarCambios={handleCancelarCambiosEspecialidadAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarespecialidades' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarEspecialidad idEspecialidad={especialidad?.id || 0} guardarCambios={handleGuardarCambiosEspecialidadAdmin} cancelarCambios={handleCancelarCambiosEspecialidadAdmin} eliminando={true}/>
                        </div>
                    )}


                    {/* Rubros */}
                    {seleccionActual === 'listarrubros' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarRubros defaultItemsPerPage={10} handleEdit={handleEditRubroAdmin} handleDelete={handleDeleteRubroAdmin} handleAdd={handleAddRubroAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarrubros' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarRubro idRubro={rubro?.id || 0} guardarCambios={handleGuardarCambiosRubroAdmin} cancelarCambios={handleCancelarCambiosRubroAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarrubros' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarRubro idRubro={0} guardarCambios={handleGuardarCambiosRubroAdmin} cancelarCambios={handleCancelarCambiosRubroAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarrubros' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarRubro idRubro={rubro?.id || 0} guardarCambios={handleGuardarCambiosRubroAdmin} cancelarCambios={handleCancelarCambiosRubroAdmin} eliminando={true}/>
                        </div>
                    )}


                    {/* Servicios */}
                    {seleccionActual === 'listarservicios' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarServicios defaultItemsPerPage={10} handleEdit={handleEditServicioAdmin} handleDelete={handleDeleteServicioAdmin} handleAdd={handleAddServicioAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarservicios' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarServicio idServicio={servicio?.id || 0} guardarCambios={handleGuardarCambiosServicioAdmin} cancelarCambios={handleCancelarCambiosServicioAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarservicios' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarServicio idServicio={0} guardarCambios={handleGuardarCambiosServicioAdmin} cancelarCambios={handleCancelarCambiosServicioAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarservicios' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarServicio idServicio={servicio?.id || 0} guardarCambios={handleGuardarCambiosServicioAdmin} cancelarCambios={handleCancelarCambiosServicioAdmin} eliminando={true}/>
                        </div>
                    )}

                    {/* Partners */}
                    {seleccionActual === 'listarpartners' && accionActual === '' && (
                        <>
                            <div className="flex flex-col justify-start items-center w-full h-full">
                                <ListarPartners defaultItemsPerPage={10} handleEdit={handleEditPartnerAdmin} handleDelete={handleDeletePartnerAdmin} handleAdd={handleAddPartnerAdmin} />
                            </div>
                            <div>
                                <MapModal
                                    ubicacion={laUbicacion}
                                    isOpen={mapaIsOpen}
                                    onClose={() => setMapaIsOpen(false)}
                                />
                            </div>
                        </>                        
                    )}
                    {seleccionActual === 'listarpartners' && accionActual === 'editar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPartner idPartner={partner?.id || 0} guardarCambios={handleGuardarCambiosPartnerAdmin} cancelarCambios={handleCancelarCambiosPartnerAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpartners' && accionActual === 'agregar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPartner idPartner={0} guardarCambios={handleGuardarCambiosPartnerAdmin} cancelarCambios={handleCancelarCambiosPartnerAdmin} eliminando={false}/>
                        </div>
                    )}
                    {seleccionActual === 'listarpartners' && accionActual === 'eliminar' && (
                        <div className="flex flex-col justify-start items-center w-full h-full">
                            <EditarPartner idPartner={partner?.id || 0} guardarCambios={handleGuardarCambiosPartnerAdmin} cancelarCambios={handleCancelarCambiosPartnerAdmin} eliminando={true}/>
                        </div>
                    )}


                </main>
            </div>
        </div>
    );
};

export default Admin;
